export const TOKEN_KEY = 'token';
export const OTT_INFO_KEY = 'ottInfo';
export const USER_INFO_KEY = 'userInfo';
